<template>
    <section class="track-page">
        <div class="track-page__wrapper">
            <div class="track-page__header">
                <ListHeader
                    title="Трек возможностей"
                    :totalCount="totalCount"
                    :titleTotalCount="titleTrackCountText"
                    without-margin
                >
                    <template v-slot:prev-count v-if="isMobile">
                        <div class="track-page__prev-count" @click="openModal">
                            <IconSettings />
                        </div>
                    </template>
                    <template v-slot:count-default v-if="isMobile">
                        <div class="track-page__prev-count" @click="openModal">
                            <IconSettings />
                        </div>
                    </template>
                    <template v-slot:info>
                        Твоя персональная подборка возможностей президентской платформы: конкурсов, проектов, обучения и
                        стажировок — развивайся и достигай большего!
                    </template>
                </ListHeader>
            </div>
            <div class="track-page__content">
                <MyInterests v-if="!isMobile && activeTab !== 'myTrack'" />
                <TrackCatalog :isFullWidth="activeTab === 'myTrack'" />
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import strCounter from '@/tools/str_counter';

import ListHeader from '@/components/UI/list-header/ListHeader';
import TrackCatalog from '@/views/track/components/TrackCatalog.vue';
import MyInterests from '@/views/track/components/MyInterests.vue';
import IconSettings from '@/views/track/icons/IconSettings.vue';
import { securityService } from '@/tools/sequrity_service';

export default {
    name: 'TrackComponent',
    components: {
        ListHeader,
        TrackCatalog,
        MyInterests,
        IconSettings,
    },
    computed: {
        ...mapGetters('auth', ['isAuthorized', 'isAuthReady']),
        ...mapGetters('track', [
            'userCompetencies',
            'userCourseAreas',
            'allRecommendationCount',
            'allFavoriteCount',
            'allMyActivityCount',
            'activeTab',
        ]),
        ...mapGetters('data', ['getRegistryItems']),
        ...mapGetters(['isMobile']),
        titleTrackCountText() {
            return strCounter('возможност', 'ь', 'и', 'ей')(this.totalCount);
        },
        totalCount() {
            switch (this.activeTab) {
                case 'recommendations':
                    return this.allRecommendationCount;
                case 'favorites':
                    return this.allFavoriteCount;
                case 'myTrack':
                    return this.allMyActivityCount;
                default:
                    return 0;
            }
        },
    },
    methods: {
        ...mapActions('track', [
            'fetchAllInterests',
            'fetchMyInterests',
            'fetchMyRecommendations',
            'fetchFavorites',
            'fetchFavoriteEntities',
            'addUserCompetence',
            'addUserCourseArea',
            'openDialogSelectInterests',
            'setIsLoadingRecommendations',
            'setIsFirstLoaded',
            'setActiveTab',
        ]),
        ...mapActions('data', ['loadRegistryItems']),

        openModal() {
            if (this.isAuthorized) {
                this.openDialogSelectInterests();
            } else {
                if (this.userCompetencies.length > 0 || this.userCourseAreas.length > 0) {
                    securityService.signIn();
                }

                if (this.userCompetencies.length === 0 && this.userCourseAreas.length === 0) {
                    this.openDialogSelectInterests();
                }
            }
        },
    },

    async mounted() {
        let fetchProjectTypes = async () => {};

        if (this.getRegistryItems('spk_project_type').length === 0) {
            fetchProjectTypes = async () =>
                await this.loadRegistryItems({ type: 'spk_project_type', withDeleted: true });
        }

        let fetchProjectStatus = async () => {};

        if (this.getRegistryItems('spk_project_type').length === 0) {
            fetchProjectStatus = async () => await this.loadRegistryItems({ type: 'stage_history', withDeleted: true });
        }

        if (this.isAuthorized) {
            const myLocalInterests = {
                courseAreas: JSON.parse(localStorage.getItem('selectedCourseAreas')) || [],
                competencies: JSON.parse(localStorage.getItem('selectedCompetencies')) || [],
            };

            const myInterests = await this.fetchMyInterests(true);

            const myNewInterests = {
                courseAreas: [
                    ...new Set(
                        [...myLocalInterests.courseAreas, ...myInterests.courseAreas].map((item) =>
                            JSON.stringify(item)
                        )
                    ),
                ].map((item) => JSON.parse(item)),
                competencies: [
                    ...new Set(
                        [...myLocalInterests.competencies, ...myInterests.competencies].map((item) =>
                            JSON.stringify(item)
                        )
                    ),
                ].map((item) => JSON.parse(item)),
            };

            if (localStorage.getItem('promoTrackWasViewed') === null) {
                this.openDialogSelectInterests();
            }

            await Promise.all([
                this.addUserCompetence(myNewInterests.competencies.map((comp) => comp.id)),
                this.addUserCourseArea(myNewInterests.courseAreas.map((area) => area.id)),
            ]);

            localStorage.removeItem('selectedCourseAreas');
            localStorage.removeItem('selectedCompetencies');

            await Promise.all([
                this.fetchFavorites(),
                this.fetchAllInterests(),
                this.fetchMyInterests(true).then(() => this.fetchMyRecommendations()),
                fetchProjectStatus(),
                fetchProjectTypes(),
            ]);
            this.fetchFavoriteEntities();
        } else {
            // Забрать интересы из localStorage
            const selectedCourseAreas = JSON.parse(localStorage.getItem('selectedCourseAreas')) || [];
            const selectedCompetencies = JSON.parse(localStorage.getItem('selectedCompetencies')) || [];

            if (selectedCourseAreas.length > 0 || selectedCompetencies.length > 0) {
                await Promise.all([
                    this.fetchAllInterests(),
                    this.fetchMyInterests(false).then(() => this.fetchMyRecommendations()),
                    fetchProjectTypes(),
                ]);
            } else {
                if (localStorage.getItem('promoTrackWasViewed') === null) {
                    this.openDialogSelectInterests();
                }
            }
        }

        localStorage.setItem('isPromoTrack', 'false');
        localStorage.setItem('promoTrackWasViewed', 'true');
        this.setIsFirstLoaded();
        this.setIsLoadingRecommendations(false);
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.track-page {
    width: 100%;
    height: 100%;
    font-family: $font-montserrat;
    padding-top: urem(16);
    padding-bottom: urem(40);

    @include on-desktop {
        padding: 0;
        background: white;
    }

    * {
        font-family: inherit;
    }

    &__wrapper {
        padding-top: mrem(16);
        border-radius: mrem(16);
        background: white;

        @include on-desktop {
            min-height: 100vh;
            min-height: 100dvh;
            min-width: 100vw;
            min-width: 100dvw;
            width: rem(1608);
            margin: 0 auto;
            min-width: 0;
            padding-top: rem(50);
            padding-bottom: rem(40);
            border-radius: 0;
        }
    }

    &__header {
        padding: 0 urem(20) 0 urem(20);

        @include on-desktop {
            padding: 0;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;

        @include on-desktop {
            padding-top: 0;
            flex-direction: row-reverse;
            align-items: flex-start;
            gap: urem(40);
        }
    }

    &__prev-count {
        display: flex;
        align-items: center;
        justify-content: center;
        width: urem(32);
        height: urem(32);
        border-radius: 50%;
        cursor: pointer;
        background-color: rgba(240, 239, 245, 1);
        box-shadow: 0px 0px 4px 0px rgba(70, 99, 171, 0.35);
    }
}
</style>
